import { API_BASE } from './config';
import { apiCache, TTL } from './cache';

const BASE = `${API_BASE}/api/Locations`;

export interface Province {
  id: number;
  name: string;
}

export interface Town {
  id: number;
  name: string;
  provinceId: number;
}

export async function fetchProvinces(): Promise<Province[]> {
  const cached = apiCache.get<Province[]>('provinces');
  if (cached) return cached;
  const res = await fetch(`${BASE}/provinces`);
  if (!res.ok) throw new Error('Failed to fetch provinces');
  const data: Province[] = await res.json();
  apiCache.set('provinces', data, TTL.FOREVER);
  return data;
}

export async function fetchTowns(provinceId: number): Promise<Town[]> {
  const key = `towns:${provinceId}`;
  const cached = apiCache.get<Town[]>(key);
  if (cached) return cached;
  const res = await fetch(`${BASE}/towns?provinceId=${provinceId}`);
  if (!res.ok) throw new Error('Failed to fetch towns');
  const data: Town[] = await res.json();
  apiCache.set(key, data, TTL.FOREVER);
  return data;
}
